import {
    buildSchema,
} from "@camberi/firecms";

const faqSchema = buildSchema({
    name: "faqs",
    properties: {
        question: {
            dataType: "string",
            title: "Question",
            validation: {
                required: true,
                
            },
            config:{
                multiline:true,
            }
        },
        answer: {
            dataType: "string",
            title: "Answer",
            columnWidth: 500,
            validation: {
                required: true
            },
            config:{
                multiline: true,
            }
        },
        updated_at: {
            dataType: "timestamp",
            title: "Updated At",
            autoValue:"on_update",
            columnWidth:400,
        },
        publish: {
            dataType: "boolean",
            title: "Publish",
            validation: {
                required: true,
                
            },
            columnWidth:200
            
            
        },
    }
});

faqSchema.onSaveSuccess = () => {
    console.log("onSaveSuccess");
};

export default faqSchema;